export const PlatformErrorCodes = {
    "ConnectionError": 1011,
    "Reconnect": 1012,
    "GameIsOpen": 1013,
    "NotEnoughMoney":1014
}